export default function restVuex(resourceName, { api, selectList = (resp) => resp.data, selectUpdate = (resp) => resp.data, idKey = "_id", extend = {} } = {}) {
  if (!api || !api.fetch || !api.create || !api.update) {
    throw new Error(`[restVuex:${resourceName}] Debes pasar una "api" con fetch/create/update`);
  }

  const baseModule = {
    namespaced: true,

    state: {
      data: [],
      loading: false,
      error: null,
      current: null,
      loaded: false,
      ...(extend.state || {}),
    },

    actions: {
      async fetch({ commit }, query) {
        commit("setLoading", true);
        try {
          const resp = await api.fetch(query);
          const list = selectList(resp) ?? [];
          commit("setData", Array.isArray(list) ? list : []);
          commit("setLoaded", true);
        } catch (e) {
          commit("setError", normalizaError(e));
        }
      },

      async search({ commit }, query) {
        commit("setLoading", true);
        try {
          const fn = api.search || api.fetch;
          const resp = await fn(query);
          const list = selectList(resp) ?? [];
          commit("setData", Array.isArray(list) ? list : []);
          commit("setLoaded", true);
        } catch (e) {
          commit("setError", normalizaError(e));
        }
      },

      async create({ commit }, payload) {
        commit("setLoading", true);
        try {
          const resp = await api.create(payload);
          const item = selectUpdate(resp);
          commit("add", item);
          commit("setLoaded", true);
        } catch (e) {
          commit("setError", normalizaError(e));
        }
      },

      async update({ commit }, { id, data }) {
        commit("setLoading", true);
        try {
          const resp = await api.update(id, data);
          const item = selectUpdate(resp);
          commit("update", item);
          commit("setLoaded", true);
        } catch (e) {
          commit("setError", normalizaError(e));
        }
      },

      ...(extend.actions || {}),
    },

    mutations: {
      setLoading(state, val = true) {
        state.loading = val;
        if (val) state.error = null;
      },
      setError(state, err) {
        state.error = err;
        state.loading = false;
      },
      setData(state, list) {
        state.data = list || [];
        state.loading = false;
        state.error = null;
      },
      setCurrent(state, item) {
        state.current = item || null;
        state.loading = false;
      },
      add(state, item) {
        if (!item) return;
        state.data.push(item);
        state.loading = false;
      },
      update(state, item) {
        if (!item) return;
        const id = item[idKey];
        const idx = state.data.findIndex((x) => x[idKey] === id);
        if (idx !== -1) state.data.splice(idx, 1, item);
        state.loading = false;
      },
      setLoaded(state, val) {
        state.loaded = !!val;
      },
      ...(extend.mutations || {}),
    },

    getters: {
      getData: (s) => s.data,
      getLoading: (s) => s.loading,
      getError: (s) => s.error,
      getLoaded: (s) => s.loaded,
      ...(extend.getters || {}),
    },
  };

  return baseModule;
}

function normalizaError(e) {
  return e?.response?.data?.error || e?.message || "Error inesperado";
}
